import { styled } from '@mui/material/styles';
import Skeleton from '@mui/material/Skeleton';

const Wrapper = styled('div')({
    padding: 16,
    width: 730,
    maxWidth: '100%',
    boxSizing: 'border-box',
    '@media (max-width: 1024px)': {
        padding: 12,
        width: '100%',
    },
});

const FullSkeleton = styled(Skeleton)({
    height: 'calc(var(--100vh) - 200px)',
    '@media (max-width: 600px)': {
        height: 'calc(var(--100vh) - 142px)',
    },
});

const SkeletonBody = () => (
    <Wrapper>
        <FullSkeleton variant="rounded" />
    </Wrapper>
);

export default SkeletonBody;
